import type { OpenShiftRequest } from "../../../utils/models";

/**
 * What a posted request pays whoever picks it up right now — the read every approve and display path makes
 * (`RequestUtilsProvider.approveAddRequest`, `RequestItem`, `OpenShiftCard`).
 *
 * DEFAULT: `current_bonus` is filled only when the request carries an incentive plan (the backend resolves the
 * decay curve at read time); without one it is absent and `bonus` IS the value — the backend documents this as
 * "clients read current_bonus ?? bonus" (`models/requests.py`). A request offering nothing has `bonus: 0` in the
 * model (backend default `0.0`), so it contributes 0 because it offers 0, not because a value was missing.
 */
export const currentRequestBonus = (request: Pick<OpenShiftRequest, "bonus" | "current_bonus">): number => request.current_bonus ?? request.bonus;
